import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useOccConfig } from '../../context/occ/hooks/use-occ-config';
import { RecaptchaV2 } from './recaptcha-v2/recaptcha-v2';
const CaptchaBase = (props, forwardedRef) => {
    const { onValueChanged, className } = props;
    const { captcha: captchaConfig } = useOccConfig().security;
    const captchaRef = useRef(null);
    useImperativeHandle(forwardedRef, () => ({
        reset: () => {
            const captchaInstance = captchaRef.current;
            captchaInstance === null || captchaInstance === void 0 ? void 0 : captchaInstance.reset();
        },
        runCaptchaTest: () => {
            const captchaInstance = captchaRef.current;
            captchaInstance === null || captchaInstance === void 0 ? void 0 : captchaInstance.runCaptchaTest();
        }
    }));
    if (!captchaConfig) {
        throw new Error('Cannot render the Captcha component when Captcha is not configured.');
    }
    return (_jsx(RecaptchaV2, { ref: captchaRef, siteKey: captchaConfig.siteKey, size: captchaConfig.size, onValueChanged: onValueChanged, className: className }));
};
export const Captcha = observer(forwardRef(CaptchaBase));
Captcha.displayName = 'Captcha';
